import { useMemo } from "react";
import { isServer } from "../util";

export const useSupportStartAtFormat = (supportStartAtString: string): string | null => {
  return useMemo<string | null>(() => {
    const supportStartAt = new Date(supportStartAtString);
    return new Date() < supportStartAt ? supportStartAt.toLocaleString() : null;
  }, [supportStartAtString]);
};
